import React from 'react';

/**
 * Horizontal underline tab row.
 * tabs: [{ id, label }]
 */
export default function SubTabs({ tabs, active, onChange }) {
  return (
    <div className="v2-subtabs">
      {tabs.map(t => (
        <button
          key={t.id}
          type="button"
          className={`v2-subtab${active === t.id ? ' v2-subtab--active' : ''}`}
          onClick={() => onChange(t.id)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
